export {
  DeviceInfoContextProvider,
  useDeviceInfoContext,
} from './DeviceInfoContext';
